import { useUserProfile } from '@/hooks/useUserProfile';
import { Card, CardContent, CardHeader, CardSubtitle } from '@/components/Card';
import { PageSpinner } from '@/components/PageSpinner';
import { ErrorState } from '@/components/ErrorState';

/** Port of user-profile.page.ts / user-profile.page.html. */
export default function UserProfilePage() {
  // Read through the query object so isPending/isError narrow `data`.
  const profileQuery = useUserProfile();

  if (profileQuery.isPending) return <PageSpinner message="Loading your profile..." />;
  if (profileQuery.isError) {
    return (
      <ErrorState
        title="Could not load your profile"
        error={profileQuery.error}
        onRetry={() => void profileQuery.refetch()}
      />
    );
  }

  const data = profileQuery.data;

  const fields = [
    { label: 'User ID / email address', value: data.email },
    { label: 'Full name', value: data.name },
    { label: 'Customer ID', value: data.customerId },
  ];

  return (
    <div className="mx-auto max-w-2xl px-4 py-6">
      <h1 className="text-center text-2xl font-semibold text-slate-900">User profile</h1>

      <div className="mt-6 space-y-4">
        {fields.map((field) => (
          <Card key={field.label}>
            <CardHeader>
              <CardSubtitle>{field.label}</CardSubtitle>
            </CardHeader>
            <CardContent>
              <p className="text-slate-900">{field.value || '—'}</p>
            </CardContent>
          </Card>
        ))}

        <Card>
          <CardHeader>
            <CardSubtitle>Role</CardSubtitle>
          </CardHeader>
          <CardContent>
            <span className="inline-flex rounded-full bg-secondary px-3 py-1 text-sm font-medium text-slate-900 capitalize">
              {data.role}
            </span>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
